import React from 'react';
import { useTranslation } from 'react-i18next';
import rem from '../../utils/rem';
import { Flex, Text } from '../primitives';

type Props = {
  size: number;
  isOnGallery?: boolean;
};

export const ModerationOverlay = ({ size, isOnGallery = false }: Props) => {
  const { t } = useTranslation();

  return (
    <Flex
      position={isOnGallery ? 'absolute' : 'relative'}
      top={isOnGallery ? rem(22) : null}
      justifyContent="center"
      alignItems={isOnGallery ? 'center' : 'flex-end'}
      size={rem(size)}
      backgroundColor={'rgba(255, 255, 255, 0.85)'}
    >
      <Text
        fontSize={isOnGallery ? 'size14' : 'size12'}
        lineHeight={isOnGallery ? rem(24) : rem(12)}
        textAlign="center"
        fontWeight={600}
        mb={isOnGallery ? 0 : 'small'}
      >
        {t('moderation.label')}
      </Text>
    </Flex>
  );
};

export default ModerationOverlay;
